import { useTranslation } from 'react-i18next'
import { GetPriceResponse } from '@leid/api-orders'

import { Pricing } from 'appTypes/items'
import { removeDecimals } from 'utils/removeDecimals'

import SwitchBox from '../../../SwitchBox'
import SafeWithLeidArticle from '../SafeWithLeidArticle'
import { JSX } from 'react'

type Props = {
  value: boolean | undefined
  fieldName: string
  pricings: Pricing[]
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  productPrice: GetPriceResponse | null
  amount: number
}

const IncludeDeductiblesSwitch = (props: Props): JSX.Element => {
  const { pricings, setFieldValue, value, fieldName, productPrice, amount } = props

  const { t } = useTranslation(['common'])

  const activePricing = productPrice ? pricings.find((s) => s.id === productPrice.pricingId) : undefined

  const getPrice = () => {
    return (activePricing?.deductiblesPrice ?? 0) * amount
  }

  const hide =
    !activePricing ||
    !activePricing.deductiblesPrice ||
    activePricing.deductiblesPrice === 0 ||
    activePricing.deductiblesAmount === 0
  const price = getPrice()

  return (
    <>
      {!hide && (
        <SwitchBox
          title={t('reductionOfDeductible')}
          price={price}
          topExtraText={
            activePricing.deductiblesAmount === null && !value
              ? t('standardDeductibles')
              : `${t('deductible')} ${value ? '0' : removeDecimals(activePricing.deductiblesAmount)} ${t('NOK')}`
          }
          bottomExtraText={<SafeWithLeidArticle />}
          onChange={(value) => {
            setFieldValue(fieldName, value)
          }}
          defaultChecked={value}
        />
      )}
    </>
  )
}

export default IncludeDeductiblesSwitch
